import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { finalizeFullEval } from "@/api/endpoints/maturity";

export function useFinalizeMaturityFull(sessionId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => finalizeFullEval(sessionId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.maturity.evaluation(sessionId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.credits.all,
      });
    },
  });
}
